import { Link, useLocation } from "react-router-dom";

import { cn } from "@/lib/utils";
import { ACCOUNT_SECTIONS, isSectionActive } from "./account-sections";

/**
 * Phone replacement for the cabinet sidebar: three always-visible sections instead of a
 * second ☰ next to the header's. Styled as a filled segmented control (not an underline)
 * and placed above the page title, so it never reads as part of a page's AccountTabs filters.
 * Links with aria-current rather than ui/tabs: these go to other routes, not tab panels.
 */
export function AccountSectionNav() {
  const { pathname } = useLocation();

  return (
    <nav aria-label="Разделы кабинета" className="mb-4">
      <ul className="flex gap-1 rounded-lg border border-border bg-secondary p-1">
        {ACCOUNT_SECTIONS.map((section) => {
          const isActive = isSectionActive(section.path, pathname);
          return (
            // min-w-0 + truncate: the labels fill a 320px screen almost exactly, so enlarged
            // text clips a label instead of pushing the whole page into horizontal scroll.
            <li key={section.id} className="min-w-0 flex-auto">
              <Link
                to={section.path}
                aria-current={isActive ? "page" : undefined}
                className={cn(
                  "flex min-h-touch min-w-0 items-center justify-center rounded-md px-2 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                  isActive
                    ? "bg-primary text-primary-foreground shadow-panel"
                    : // secondary-foreground, not muted: muted grey on this track is ~4.2:1.
                      "text-secondary-foreground hover:bg-card hover:text-foreground",
                )}
              >
                <span className="truncate">{section.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
